import VerofreshRecord from './VerofreshRecord'

class RoutePlanFileUploadRoutePlanRecord extends VerofreshRecord {
  static endpoint = 'route-plan-file-upload-route-plan'

  /**
   * Get human-readable action text
   */
  get actionText () {
    const actionLabels = {
      created: 'Created',
      updated: 'Updated',
      failed: 'Failed'
    }
    return actionLabels[this.action] || 'Unknown'
  }

  /**
   * Check if the action was successful
   */
  get isSuccessful () {
    return this.action === 'created' || this.action === 'updated'
  }
}

const relations = {
  belongsTo: {
    RoutePlanFileUpload: {
      foreignKey: 'route_plan_file_upload_id',
      localField: 'route_plan_file_upload'
    },
    RoutePlan: {
      foreignKey: 'route_plan_id',
      localField: 'route_plan'
    }
  }
}

export default RoutePlanFileUploadRoutePlanRecord
export { relations }